/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'getDrawSystemGameTypeCreditByCustomerId',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_CREDIT_BY_CUSTOMER_ID,
    method: 'GET',
    path: '/draw/:drawId/system-game/:systemGameId/credit/:customerId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_CREDIT,
    requestSchema: requestSchemas.drawSystemGames.getDrawSystemGameCreditByCustomerId,
  },
  {
    action: 'getDrawSystemGameTypeCredits',
    message: messages.SUCCESS_GET_DRAW_SYSTEM_GAME_CREDITS,
    method: 'GET',
    path: '/draw/:drawId/system-game/:systemGameId/credits',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_DRAW_SYSTEM_GAME_CREDIT,
    requestSchema: requestSchemas.drawSystemGames.getDrawSystemGameCredits,
  },
];
